Globals = {};
Globals.NUM_PRE_APPERATURE_SYMBOLS = 7;
Globals.NUM_POST_APPERATURE_SYMBOLS = 2;
Globals.NUM_ROWS = 5;
Globals.NUM_REELS = 5;
Globals.ALLOWED_SYMBOLS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; // no wilds or bonus
Globals.GB_MULTIPLIER = 1.3;
Globals.THREE_SCATTERS_AWARD = 7;
Globals.FOUR_SCATTERS_AWARD = 10;
Globals.FIVE_SCATTERS_AWARD = 15;
Globals.NUM_SYMBOLS = 12;
Globals.BONUS_ID = 11;
